import type { ExtractInjectionAPI } from '@atlaskit/editor-common/types';
import type { AIPlugin } from '@atlassian/editor-plugin-ai';

import { type StreamingCommand } from '../aiStreamingOrchestratorPluginType';

import { createAppendNodeCommand } from './append';
import { createInsertNodeAfterCommand } from './insert-after';
import { createInsertNodeBeforeCommand } from './insert-before';
import { createRemoveNodeCommand } from './remove';
import { createReplaceNodeCommand } from './replace';
import { createWrapNodeCommand } from './wrap';

/**
 * Creates a mapping of streaming command types to their corresponding command factories.
 * @param api - The API object containing the editor's core functionality.
 * @returns A mapping of streaming command types to their corresponding command factories.
 */
export function createStreamingCommands(api: ExtractInjectionAPI<AIPlugin>) {
	return {
		replaceNode: createReplaceNodeCommand(api),
		insertNodeBefore: createInsertNodeBeforeCommand(api),
		insertNodeAfter: createInsertNodeAfterCommand(api),
		removeNode: createRemoveNodeCommand(api),
		appendNode: createAppendNodeCommand(api),
		appendNodeToEnd: createAppendNodeCommand(api),
		wrap: createWrapNodeCommand(api),
		wrapNode: createWrapNodeCommand(api),
	} as Record<StreamingCommand['type'], (command: StreamingCommand) => boolean>;
}
